<nb-layout class="auth">
	<nb-layout-column class="padding-0">
		 <router-outlet></router-outlet>
	</nb-layout-column>
</nb-layout>
